<template>
  <div>
    <filter-targeted-content :filterStatus="filterStatus" @filter-item="filterBanners" />

    <div class="container mx-auto">
      <empty
        v-if="loaded && banners.length === 0"
        icon="water"
        title="No banners on the horizon"
        message="The weather is not optimal for surfing the banners."
      >
      </empty>

      <div v-else-if="loaded && banners.length > 0" class="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
        <div class="inline-block min-w-full shadow rounded-lg overflow-hidden">
          <table class="min-w-full leading-normal">
            <thead>
              <tr>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Name
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  <el-tooltip
                    effect="dark"
                    content="To test the banner, send header X-Banner-Code: XXX and X-Lang: fr"
                    placement="top"
                    ><span class="cursor-pointer">Code (?)</span></el-tooltip
                  >
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Status
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Who
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  Where
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  When
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider"
                >
                  <el-tooltip effect="dark" content="Unique Banner Views" placement="top"
                    ><span class="cursor-pointer">UBV (?)</span></el-tooltip
                  >
                </th>
                <th
                  class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                ></th>
              </tr>
            </thead>
            <tbody>
              <banners-ui-item-list
                v-for="banner in banners"
                :key="banner.id"
                :banner-id="banner.id"
                :viewsUnique="viewsUnique"
                :isOpenTableGiven="isOpenTable"
                :banners="banners"
              />
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="loaded && banners.length > 0" class="text-right px-2">
        <p v-if="banners.length > 1">{{ banners.length }} results</p>
        <p v-else>{{ banners.length }} result</p>
      </div>
    </div>
  </div>
</template>

<script>
import Empty from '@/components/box-entity-empty.vue'
import FilterTargetedContent from '@/components/common/ui/form/filter-targeted-content.vue'

import { mapActions, mapGetters} from 'vuex'

export default {
  name: 'BannerUiList',

  components: { Empty, FilterTargetedContent, FilterTargetedContent },

  data () {
    return {
      banners: [],
      viewsUnique: [],
      isOpenTable: [],
      bannerToDelete: null,
      loaded: false,
      deleteBannerModalConfirmation: null,
      filterStatus: 'all'
    }
  },
  watch: {
    site: {
      handler: 'init',
      immediate: true
    }
  },
  computed: {
    ...mapGetters('banners', {
      allBanners: 'banners',
      bannersByStatus: 'getByStatus',
      getFilterStatus: 'getFilterStatus'
    }),
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    })
  },
  methods: {
    ...mapActions('banners', ['loadBanners', 'getBannerStats', 'removeBanner', 'addBanner', 'setFilterStatus']),

    init () {
      this.loadBanners().then(() => {
        this.loaded = true
        this.filterStatus = this.getFilterStatus
        this.banners = this.bannersByStatus(this.filterStatus)
        this.getUniqueViews(this.banners)
        this.getTableBoolean(this.banners)
        this.getUrlTargetToString(this.banners)
      })
    },
    getUniqueViews(banners) {
      this.viewsUnique = [];

      for (let banner of banners) {
        if (banner.status !== 'enable' && 'views' in banner && banner.views !== null) {
          this.viewsUnique.push({
            id: banner.id,
            views: banner.views.views.unique ? banner.views.views.unique.toString() : '0'
          });
        } else {
          this.getBannerStats({ id: banner.id }).then((data) => {
            this.viewsUnique.push({
              id: data.id,
              views: (data.results.views.unique ? data.results.views.unique : 0).toString()
            });
          });
        }
      }
    },
    getTableBoolean (banners) {
      for (let i = 0; i < banners.length; ++i) {
        this.isOpenTable[i] = false
      }
    },
    getUrlTargetToString(banners) {
      for (let banner of banners) {
        let urlString = ""
        banner.url_target_list.forEach((path, index) => {
          if (index === 0) {
            urlString += path
          } else {
            urlString += ', ' + path
          }
        })
        banner.url_target_string = urlString;
      }
    },

    filterBanners (filterStatus) {
      this.filterStatus = filterStatus
      this.banners = this.bannersByStatus(filterStatus)
      this.setFilterStatus({filterStatus})
    },

    mounted () {
      this.init()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/banners/ui/list.vue